export default __webpack_public_path__ + "static/media/stamp8.cc187447.png";